import React from "react"
import { Form } from "react-bootstrap"
import { useField } from "formik"
import Feedback from "./Feedback"

import FloatableGroup from "./FloatableGroup"

const File = ({
  label = undefined,
  floating = false,
  validationMessage = null,
  ...props
}): JSX.Element => {
  const [field, meta, helpers] = useField(props)

  return (
    <FloatableGroup label={label} floating={floating}>
      <Form.Control
        type="file"
        {...props}
        onChange={(event) =>
          helpers.setValue({ ...props.value, value: event.currentTarget.files[0] })
        }
      />
      <Feedback.Invalid message={validationMessage} />
    </FloatableGroup>
  )
}

export default File
